var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"superset-wrapper"},[(_vm.loading)?_c('div',{staticClass:"superset-loading"},[_c('span',[_vm._v("Loading dashboard…")])]):_vm._e(),(_vm.error)?_c('div',{staticClass:"superset-error"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_c('div',{ref:"mount",staticClass:"superset-mount"})])
}
var staticRenderFns = []

export { render, staticRenderFns }